<script>
export default {
  name: 'CustomAutocomplete',
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [Array, String, Number, Object, Boolean],
      default: null
    },
    noDataText: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue'],
  computed: {
    proxyModelValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    autocompleteAttrs() {
      const attrs = { ...this.$attrs }
      delete attrs['no-data-text']
      return attrs
    },
    resolvedNoDataText() {
      return this.noDataText ?? this.$t('COMMON.NO_DATA')
    },
    selectedCount() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.length
      }

      return this.modelValue === null || this.modelValue === undefined || this.modelValue === ''
        ? 0
        : 1
    },
    otherSelectionLabel() {
      const count = this.selectedCount - 1
      const key = count === 1 ? 'COMMON.INPUTS.OTHER_SELECTED' : 'COMMON.INPUTS.OTHERS_SELECTED'

      return this.$t(key, { count })
    }
  }
}
</script>

<template>
  <v-autocomplete
    v-bind="autocompleteAttrs"
    v-model="proxyModelValue"
    :no-data-text="resolvedNoDataText"
  >
    <template #selection="slotProps">
      <slot v-if="$slots.selection" name="selection" v-bind="slotProps" />
      <template v-else>
        <v-chip v-if="slotProps.index < 1">
          <span>{{ slotProps.item.title }}</span>
        </v-chip>
        <span
          v-else-if="slotProps.index === 1 && selectedCount > 1"
          class="text-grey text-caption align-self-center"
        >
          {{ otherSelectionLabel }}
        </span>
      </template>
    </template>

    <template #item="{ item, props }">
      <v-list-item :title="item.title" :value="item.value" v-bind="props">
        <template #title>
          <span class="truncate" :title="item.title">
            {{ item.title }}
          </span>
        </template>
      </v-list-item>
    </template>

    <template v-if="$slots['prepend-item']" #prepend-item>
      <slot name="prepend-item" />
    </template>

    <template v-if="$slots['append-item']" #append-item>
      <slot name="append-item" />
    </template>

    <template v-if="$slots['no-data']" #no-data>
      <slot name="no-data" />
    </template>
  </v-autocomplete>
</template>
